import classNames from 'classnames';
import * as React from 'react';

import css from './BooksTextInput.module.scss';

export enum TextInputType {
  Date = 'date',
  Email = 'email',
  Number = 'number',
  Password = 'password',
  Tel = 'tel',
  Text = 'text',
  TextArea = 'textarea',
}

interface Props {
  name?: string;
  className?: string;
  cols?: number;
  rows?: number;
  type?: TextInputType;
  onChange?: (e: React.ChangeEvent) => void;
  setValue?: boolean;
  value?: string;
  disabled?: boolean;
  placeholder?: string;
}

class BooksTextInput extends React.Component<Props> {
  private textarea: React.RefObject<HTMLTextAreaElement>;

  constructor(props: Props) {
    super(props);
    this.textarea = React.createRef();
  }

  public componentDidMount() {
    const textarea = this.textarea.current;
    if (!textarea) {
      return;
    }

    if (textarea.scrollHeight > textarea.offsetHeight) {
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  }

  public render() {
    const {
      className,
      cols,
      rows,
      type,
      onChange,
      setValue,
      ...attr
    } = this.props;
    const classes = classNames(
      css.BooksTextInput,
      { [css.isSetValue]: setValue },
      className,
    );
    const inputType = type || TextInputType.Text;

    return type === TextInputType.TextArea ? (
      <textarea
        {...attr}
        className={classes}
        cols={cols}
        rows={rows}
        onChange={onChange}
        ref={this.textarea}
      />
    ) : (
      <input
        {...attr}
        className={classes}
        type={inputType}
        onChange={onChange}
      />
    );
  }
}
export default BooksTextInput;
